export default {
  title: 'Tiedot',
  sections: {
    work_schedule: 'Aukioloajat: Verkkotilaus',
    delivery_schedule: 'Toimitusajat',
    delivery_costs: 'Toimituskulut',
    website: 'Verkkosivusto',
  },
  labels: {
    delivery_fees: 'Väh. summa - {{threshold}}, Maksu - {{fee}}',
  },
};
